import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

import "./assets/scss/material-kit-react.scss";
import cyberpunkTheme from './styles/GlobalCyberpunkTheme.js';

import routes from "./routes.js";

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('React Error Boundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h1>Something went wrong.</h1>
          <p>Error: {this.state.error?.message}</p>
          <pre>{this.state.error?.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={cyberpunkTheme}>
    <CssBaseline />
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {routes.map((route, index) => (
            <Route 
              key={index}
              path={route.path} 
              element={<route.component />} 
            />
          ))}
        </Routes>
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
    </ErrorBoundary>
  </ThemeProvider>
);
